import {
  Box,
  SpaceBetween,
  Grid,
  Link,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import * as awsui from "@cloudscape-design/design-tokens";
import { GlobalContext } from "../context";
import { useMediaQuery } from 'react-responsive';
import { PrimaryButton, CustomButton } from "./buttons";

export default function Announcement() {
  const navigate = useNavigate();
  const { 
    theme, setTheme, 
  } = useContext(GlobalContext);

  const isSmallDevice = useMediaQuery({query: "only screen and (max-width : 768px)"});
  const isMediumDevice = useMediaQuery({query: "only screen and (min-width : 769px) and (max-width : 992px)"});
  const isLargeDevice = useMediaQuery({query: "only screen and (min-width : 993px) and (max-width : 1200px)"});
  const isDesktop = useMediaQuery({query: "only screen and (min-width : 1201px)"});


  return (
    <>
      <Grid
        gridDefinition={[
          { colspan: { default: 12, xxs: 8, s: 6, m: 7 } },
          { colspan: { default: 10, xxs: 8, s: 6, m: 5 } },
        ]}
      >  
        <SpaceBetween size="xxl">
          <div style={{display: "flex", justifyContent: "center"}}>
            <center><h1>S5000 Round 4 Winner</h1></center>
          </div>
          <Box data-announcement>
            <p>The Motorsport Australia Racekraft S5000 2023 Eseries Round 4 unfolded in a virtual frenzy at the renowned Silverstone Circuit. Damon Woods emerged as the undisputed victor, securing his place at the summit of the championship standings. His remarkable triumph over Tim Delisle came down to the wire, with a mere 1.2 seconds separating the two talented racers at the finish line.</p>
            <p>Damon's exceptional prowess was evident throughout the entire event. From qualifying to the exciting sprint and feature races, he showcased unrivaled speed and unyielding determination. Perhaps his real-world experience in the Formula Ford racing scene played a pivotal role in granting him the decisive edge.</p>
            <p>With only six races remaining in the championship, the pressure is mounting on other drivers to bridge the gap and mount a formidable challenge against Damon's commanding lead. Join us on the 1st of August as we head to the beautiful Spa Francorchamps to see how this championship unfolds.</p>
            <br />
            If you missed the exciting race, you can watch the replay on&nbsp;
            <Link 
              href="https://www.youtube.com/watch?v=z7mEKECqwJ4&t=28s&ab_channel=RACESTARSTV-RSTVAU"
              target="_blank"
            >
              Racestars TV
            </Link>.
            <center>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/racestars-logo-dark.png" : "/images/sponsor-logos/racestars-logo-light.png"}
                alt="FRG Logo"
                width="80%"
                style={{ maxWidth: "250px", minWidth: "150px" }}
              />
            </center>
            {/* <p />
            <b>Want to compete in the Official FORMULA FORD AUSTRALIA eseries?</b>
            <p />
            <div style={{paddingTop: "20px"}}>
              <PrimaryButton 
                url="/ffa-series" 
                buttonName="Formula Ford Series" 
                buttonColor={awsui.colorBackgroundButtonPrimaryActive} 
                textColor={awsui.colorTextButtonPrimaryActive}
              />
            </div>
            <div style={{paddingTop: "20px"}}>
              <Link href="https://discord.gg/v3r7jDUc" target="_blank">
                <CustomButton
                  type="button"
                  onMouseEnter={ (event:any) => {
                    event.currentTarget.style.filter = `drop-shadow(1px 1px 3px #738ADB) hue-rotate(345deg)`;
                  }}
                  onMouseLeave={ (event:any) => {
                    event.currentTarget.style.filter = "none";
                  }}
                  style={{
                    background: "#738ADB",
                    color: "white",
                  }}
                >
                  Join our Discord
                </CustomButton>
              </Link>
            </div> */}
          </Box>
        </SpaceBetween>
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%"
        }}>
          <center>
            <img
              src={theme === Mode.Light ? "/images/announcements/announcement-image.png" : "/images/announcements/announcement-image.png"}
              alt="Announcement"
              // width={"80%"}
            />
          </center>
        </div>
      </Grid>
    </>    
  );
}
